import React, { PureComponent } from "react";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import Helmet from "react-helmet";
import {
  constructTitle,
  constructMetaTags,
  constructCanonicalLink,
} from "../../utils/helmetTagGenerator";

export class Seo extends PureComponent {
  static propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    image: PropTypes.string,
    noIndex: PropTypes.bool,
    titleOnly: PropTypes.bool,
    location: PropTypes.object.isRequired,
  };

  static defaultProps = {
    noIndex: false,
    titleOnly: false,
  };

  renderLinkTags() {
    if (this.props.noIndex) {
      return [];
    }

    return constructCanonicalLink(this.props.location.pathname);
  }

  getProps = () => {
    const { title, description, image, noIndex, location } = this.props;
    const titleProp = { title: constructTitle(title) };

    // If this.props.titleOnly is true, then just return
    // the titleProp
    if (this.props.titleOnly) {
      return titleProp;
    }

    // If this.props.titleOnly is false, then add the rest of
    // the Seo tags
    return {
      ...titleProp,
      meta: constructMetaTags({
        title,
        description,
        image,
        noIndex,
        pathname: location.pathname,
      }),
      link: this.renderLinkTags(),
    };
  };

  render() {
    return <Helmet {...this.getProps()} />;
  }
}

export default withRouter(Seo);
